import { createPinia } from 'pinia'
//import { resetStorePlugin } from './resetStorePlugin.ts'
import piniaPluginPersistedstate, {
	createPersistedState,
} from 'pinia-plugin-persistedstate'

const pinia = createPinia()

pinia.use(
	createPersistedState({
		storage: sessionStorage,
	})
)

pinia.use(piniaPluginPersistedstate)
//pinia.use(resetStorePlugin)

export { pinia }
